<template>
	<div class="copyrights">
		<template>
			<span v-for="(copyright, c) in copyrights" :key="'copyright' + c" class="copyright" :class="[
				!!unique && c == 0 ? 'copyright--unique' : '', 
				!!unique && copyrights.length > 1 ? 'copyright--withExceptions' : '', 
			]">			
				<span class="copyright__images">
					<span class="names">
						<span v-for="(name, n) in copyright.names" class="name" :key="copyright.author + n + name">{{name}}</span>
					</span>
				</span>
				<span class="copyright__author">
					{{copyright.author}}
				</span>
			</span>
		</template>
		<!--
		<template v-else>
			<span class="copyright copyright--unique">
				<span class="copyright__images">
				</span>
				<span class="copyright__author">
					{{unique}}
				</span>
			</span>
		</template>
		-->
	</div>
</template>
<script>
	export default {
		name: 'Copyrights',
		props: {
			images: {
				type: Array,
				default: () => [],
			},
			unique: {
				type: String,
				default: '',
			},
		},
		computed: {
			copyrights: function() {
				return this.images.reduce((acc, image) => {
					let author = image.author.trim()
					if (author != this.unique.trim()) {						
						let thisCopyright = acc.find(a => a.author == author)
						if (!thisCopyright) {
							thisCopyright = {
								author: author,
								names: [],
							}
							acc.push(thisCopyright)
						}
						thisCopyright.names.push(image.name.trim())
					}
					return acc
				}, !!this.unique ? [{
					author: this.unique,
					names: [''],
				}] : [])
			} 
		}
	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps';
	@import 'global/css/contexte.apps.colors';
	.copyrights {
		position: relative;
		padding-left: 5em;
		font-size: .8em;
		opacity: .8;
		&::before {
			left: 0;
			top: 1px;
			text-transform: uppercase;
			font-size: .9em;
			color: $another-grey;
			position: absolute;
			content: 'Images';
		}
	}
	.copyright {
		&__images {
			&::after {
				content: ':';
				margin-left: .2em;
			}
		}
		&:not(:last-child) {			
			.copyright__author {
				&::after {
					content: '●';
					color: $red;
					margin-right: .3em;
				}
			}
		}
		&--unique {
			.copyright__images {
				&::after {
					display: none;
				}
			}
			&.copyright--withExceptions {
				.copyright__author {
					&::after {
						color: $another-grey;
						content: ', sauf :';
						margin-left: -.2em !important;
					}
				}
			} 
		}
	}
	.name {
		@include textlist(.2em)
	}
</style>